<template>
  <section class="orders-page">
    <header class="orders-header">
      <div>
        <h1>{{ $t('account_enterprise_order') }}</h1>
        <p>{{ $t('enterprise_ui_orders_description') }}</p>
      </div>
      <span v-if="tableData.length" class="orders-header__count">{{ $t('enterprise_ui_orders_page_count', { count: tableData.length }) }}</span>
    </header>

    <div id="tradeList" class="orders-table-shell">
      <div class="orders-table-scroll">
        <div class="orders-table-header orders-table-grid">
          <span>{{ $t('enterprise_ui_order_created') }}</span>
          <span>{{ $t('enterprise_ui_order_no') }}</span>
          <span>{{ $t('enterprise_ui_order_content') }}</span>
          <span>{{ $t('enterprise_ui_order_status') }}</span>
          <span class="orders-table-header__amount">{{ $t('enterprise_ui_order_amount') }}</span>
        </div>

        <div v-if="tableData.length" class="orders-table-body">
          <div v-for="order in tableData" :key="order.id" class="orders-table-row orders-table-grid">
            <span class="orders-muted">{{ formatDate(order.createTime) }}</span>
            <span class="orders-number" :title="order.orderNo">{{ order.orderNo || '—' }}</span>
            <span class="orders-content">
              <i><WorkbenchIcon name="receipt" :size="14" /></i>
              <strong :title="order.buyContent">{{ order.buyContent || '—' }}</strong>
            </span>
            <span><em class="orders-status"><WorkbenchIcon name="check" :size="11" />{{ $t('enterprise_ui_order_completed') }}</em></span>
            <span class="orders-amount">{{ formatOrderAmount(order) }}</span>
          </div>
        </div>

        <div v-else class="orders-empty">
          <span class="orders-empty__icon"><WorkbenchIcon name="receipt" :size="28" /></span>
          <h2>{{ $t('no_data') }}</h2>
          <p>{{ $t('enterprise_ui_orders_empty') }}</p>
        </div>
      </div>
    </div>

    <footer v-if="tableData.length" class="orders-footer">
      <span>{{ $t('enterprise_ui_orders_footer') }}</span>
      <PageNation :page="pageNum" :hasMore="hasMore" @changePage="onChangePage" />
    </footer>
  </section>
</template>

<script setup lang="ts">
import AccountServer from '~/services/AccountServer'
import PageNation from "@/components/PageNation/PageNation.vue"
import WorkbenchIcon from '@/components/Workbench/WorkbenchIcon.vue'
import { type FileItem } from '~/services/AccountServer/types'
import EventBus from 'vue3-eventbus'
import { NetCode } from '~/types/const'
import useUserStore from '~/store/modules/user'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import Toast from '~/utils/toast'

const route = useRoute()
type OrderItem = FileItem & {
  orderNo?: string
  buyContent?: string
  coinType?: string
  payAmount?: number | string
  status?: number | string
  payStatus?: number | string
  tradeStatus?: number | string
  orderStatus?: number | string
}

const tableData = ref<OrderItem[]>([])
const userStore = useUserStore()
const { userInfo } = storeToRefs(userStore)
const {t} = useI18n()
const pageNum = ref(1)
const hasMore = ref(true)
const params = {pageSize: 5}

watch(userInfo, (newVal)=>{
  getEnterpriseInfo()
})

watch(route, (newVal, oldVal)=>{
  if(newVal.query.menu?.includes('orders')){
    if (userInfo.value && userInfo.value.bizTeamId) {
      requestFileList()
    }
  }
})

const getCurrencyTitle = (coinType) => {
  let coinKey = userStore.getCurrentCoinSymbol(coinType)
  return coinKey
}

const formatOrderAmount = (order: OrderItem) => {
  const amount = order.payAmount ?? '—'
  const symbol = getCurrencyTitle(order.coinType)
  return order.coinType === 'JPY' ? `${amount}${symbol}` : `${symbol}${amount}`
}

function onChangePage(change) {
  console.log("onChangePage", change)
  if (tableData.value.length > 0) {
    const lastItem = tableData.value[tableData.value.length - 1];
    const fristItem = tableData.value[0];
    if (change === 'prev') {
      pageNum.value = pageNum.value - 1
      params.prevPageId = fristItem.id
      params.nextPageId = null
    }else if (change === 'next') {
      pageNum.value = pageNum.value + 1
      params.prevPageId = null
      params.nextPageId = lastItem.id
    }
    requestFileList(false, true)
  }
}

// 获取企业人员list
function requestFileList(_isInit = false, needLoading = false) {
  let loading;
  if (needLoading) {
    let listDom = document.getElementById("tradeList")
    if (listDom) {
      loading = ElLoading.service({
        lock: true,
        target: listDom
      })
    }
  }
  let param = {
    pageSize: 5,
    prevPageId: params.prevPageId,
    nextPageId: params.nextPageId,
    // coinType: props.currency && props.currency.toLowerCase()
  }

  AccountServer.getOrderNoList(param).then((res) => {
    console.log('res===>>', res)
    if (res.code == "1") {
      let list = res.list
      if (list && list.length > 0) {
        tableData.value = list
        hasMore.value = true
        // if (list.length === params.pageSize) {
        //   hasMore.value = true
        // }else{
        //   hasMore.value = false
        // }
      }else {
        if (!params.prevPageId && !params.nextPageId) {
          tableData.value = []
        }
        if(params.nextPageId){
          Toast(t('doclingo_not_more_data'));
          hasMore.value = false
        }
        if(params.prevPageId){
          hasMore.value = true
        }
      }
    }
  }).catch((error) => {
    Toast(error.message);
  }).finally(() => {
    loading && loading.close()
  })
}

function getEnterpriseInfo(){
  // 被邀请
  if (userInfo.value && userInfo.value.bizTeamId) {
    requestFileList()
  }
}

onUnmounted(()=>{
  EventBus.off('createAccountEnterprise', getEnterpriseInfo)
})

onMounted(()=>{
  getEnterpriseInfo()
  EventBus.on('createAccountEnterprise', getEnterpriseInfo)
})

</script>

<style lang="scss" scoped>
.enterprise-page {
  max-width: 100%;
}

.page-header {
  
}

.enterprise-add-btn {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  .add-btn-text {
    font-size: 12px;
    font-weight: 400;
    color: white;
    cursor: pointer;
    padding: 8px 20px;
    background-color: #2590E1;
    border-radius: 4px;
    &:hover {
      opacity: 0.8;
    }
  }
}

.page-title {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  margin: 0;
}

.enterprise-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  // border: 1px solid #BFBFBF;
  margin-top: 40px;
  .table-header {
    display: grid;
    grid-template-columns: 20% 20% 10% 15% 15% 15% 5%;
    padding: 16px 20px;
    border-bottom: 1px solid #BFBFBF;
    font-weight: 400;
    font-size: 12px;
    color: #262626;
    background-color: #EAF5FC;
  }

  .table-body {
    // max-height: 580px;
  }

  .table-not-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 210px;
    .icon-icon_blank1 {
      font-size: 48px;
      color: #BFBFBF;
    }
    .no-data-title {
      margin-top: 10px;
      font-size: 12px;
      font-weight: 400;
      color: #BFBFBF;
    }
    .no-data-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 130px;
      height: 30px;
      background: #2590E1;
      border-radius: 4px 4px 4px 4px;
      margin-top: 30px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      .icon-icon_add_1 {
        font-size: 16px;
        color: #fff;
      }
      .no-data-text {
        font-size: 12px;
        color: #fff;
        margin-left: 6px;
      }
    }
  }

  .table-content {
    display: flex;
    flex-direction: column;
    padding: 10px 0px;
    justify-content: center;
  }

  .table-cell {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: #262626;
    font-weight: 400;
  }

  .header-cell {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #262626;
  }

  .checkbox {
    justify-content: center;
  }

  .header {
    width: 100%;
    height: 40px;
    background-color: #EAF5FC;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    padding: 0 20px;
    border: 1px solid #BFBFBF;
    .header-left {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      .header-left-text {
        font-size: 12px;
        font-weight: 400;
        color: #595959;
      }
    }
    .header-right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
      .header-right-text {
        font-size: 12px;
        font-weight: 400;
        color: #595959;
      }
    }
  }

  .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    padding: 0 20px;
    height: 57px;
    border: 1px solid #BFBFBF;
    border-top: 0px solid #BFBFBF;
    .content-left {
      display: flex;
      align-items: center;
      flex-direction: row;
      .content-left-text {
        font-size: 12px;
        font-weight: 400;
        color: #262626;
      }
    }
    .content-right {
      display: flex;
      align-items: center;
      flex-direction: row;
      .content-right-text {
        font-size: 12px;
        font-weight: 400;
        color: #262626;
      }
    }
  }
}
.pageNation {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.invited-enterprise-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  .enterprise-content-invited {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .invited-icon {
      width: 80px;
      height: 80px;
      background: #2590E1;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;
      .icon-icon_enterprise {
        font-size: 48px;
        color: #fff;
      }
    }
    .invited-title {
      font-size: 16px;
      font-weight: 500;
      color: #262626;
      max-width: 256px;
      text-align: center;
      margin-top: 10px;
    }
    .invited-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 100%;
      .invited-content-btn {
        width: 256px;
        height: 40px;
        background: #2590E1;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #2590E1;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        cursor: pointer;
        &:hover {
          opacity: 0.8;
        }
        .invited-content-btn-text {
          font-size: 14px;
          font-weight: 400;
          color: #fff;
        }
      }
    }
  }
}

</style>

<style lang="scss" scoped>
.orders-page {
  display: flex;
  min-width: 0;
  max-width: 100%;
  flex-direction: column;
  gap: 18px;
}

.orders-header {
  display: flex;
  min-height: 42px;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  h1 {
    margin: 0;
    color: #1f2329;
    font-size: 16px;
    font-weight: 800;
    line-height: 22px;
  }

  p {
    margin: 4px 0 0;
    color: #98a2b3;
    font-size: 12px;
    line-height: 16px;
  }
}

.orders-header__count {
  margin-top: 4px;
  color: #98a2b3;
  font-size: 11px;
}

.orders-table-shell {
  min-width: 0;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8ebf0;
  border-radius: 10px;
}

.orders-table-scroll {
  min-width: 0;
}

.orders-table-grid {
  display: grid;
  grid-template-columns: minmax(138px, 0.9fr) minmax(190px, 1.35fr) minmax(230px, 1.8fr) minmax(120px, 0.75fr) minmax(130px, 0.8fr);
  align-items: center;
  column-gap: 16px;
  padding: 0 16px;
}

.orders-table-header {
  min-height: 42px;
  color: #51565d;
  font-size: 12px;
  font-weight: 600;
  background: #f5f9ff;
  border-bottom: 1px solid #e8ebf0;
}

.orders-table-header__amount {
  text-align: right;
}

.orders-table-body {
  min-height: 0;
}

.orders-table-row {
  min-height: 58px;
  color: #51565d;
  font-size: 12px;
  border-bottom: 1px solid #f2f5f9;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: #fbfdff;
  }
}

.orders-muted {
  color: #7a8699;
}

.orders-number {
  overflow: hidden;
  color: #51565d;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 11.5px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.orders-content {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;

  i {
    display: inline-flex;
    width: 30px;
    height: 30px;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    color: #2b7de9;
    font-style: normal;
    background: #edf5ff;
    border-radius: 7px;
  }

  strong {
    min-width: 0;
    overflow: hidden;
    color: #1f2329;
    font-size: 12.5px;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.orders-status {
  display: inline-flex;
  height: 24px;
  align-items: center;
  gap: 4px;
  padding: 0 8px;
  color: #269d6c;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  background: #eaf8f2;
  border-radius: 999px;
}

.orders-amount {
  color: #1f2329;
  font-size: 14px;
  font-weight: 700;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.orders-empty {
  display: flex;
  min-height: 420px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;

  h2 {
    margin: 12px 0 0;
    color: #51565d;
    font-size: 13px;
    font-weight: 600;
  }

  p {
    margin: 6px 0 0;
    color: #98a2b3;
    font-size: 12px;
  }
}

.orders-empty__icon {
  display: inline-flex;
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
  color: #2b7de9;
  background: #edf5ff;
  border-radius: 14px;
}

.orders-footer {
  display: flex;
  min-height: 30px;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: #98a2b3;
  font-size: 11px;
}

@media (max-width: 900px) {
  .orders-table-shell {
    overflow-x: auto;
  }

  .orders-table-scroll {
    min-width: 860px;
  }
}
</style>
